import { ILeagueFilters } from '@/types';
import { LeagueItem } from '@/models/league';
import equal from 'fast-deep-equal';

export const useLeagueStore = defineStore('league', () => {
    const items = shallowRef<LeagueItem[]>([]);
    const total = ref<number>(0);
    const loading = ref<boolean>(false);
    const filters = reactive<ILeagueFilters>({
        name: '',
        countryId: null,
        categoryId: null,
        gender: null,
        ageCategoryId: null,
        limitsCategoryId: null,
        isFavoriteOnly: false,
    });
    const isExtraFiltersDisplayed = ref<boolean>(false);
    const favoriteLeague = ref<Record<number, number>>({});
    const favoriteLeagueProcessing = ref<Record<number, boolean>>({});

    function setFavoriteLeagues(leagues: Record<number, number>) {
        if (!equal(favoriteLeague.value, leagues)) {
            console.log('Set favorite leagues');
            favoriteLeague.value = leagues;
        }
    }

    return {
        items,
        total,
        loading,
        filters,
        isExtraFiltersDisplayed,
        favoriteLeague,
        favoriteLeagueProcessing,
        setFavoriteLeagues,
    };
});

if (import.meta.hot) {
    import.meta.hot.accept(acceptHMRUpdate(useLeagueStore, import.meta.hot));
}
